import { env } from '@/src/config/env'
import { axiosInstance } from '@/src/general/utilities/fetcher/axiosInstance'
import type { TQueryConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TGetAutocompleteData, TGetAutocompletePayload } from './types.ts/getAutocomplete.types'
import type { TGetPlaceDetailsData, TGetPlaceDetailsPayload } from './types.ts/getPlaceDetails.types'

const PLACES_API_PATH = '/places.googleapis.com/v1'

export const geoApi = {
  getAutocomplete: ({ input, includedPrimaryTypes, locale }: TGetAutocompletePayload, { signal }: TQueryConfig) =>
    axiosInstance<TGetAutocompleteData>({
      method: 'POST',
      headers: {
        'X-Goog-FieldMask': 'suggestions.placePrediction.placeId,suggestions.placePrediction.text.text',
        'Content-Type': 'application/json',
      },
      url: `${env.EXPO_PUBLIC_WEB_BASE_URL}${PLACES_API_PATH}/places:autocomplete`,
      data: {
        input,
        includedPrimaryTypes,
        languageCode: locale,
      },
      signal,
    }).then((response) => response.data),
  getPlaceDetails: ({ placeId, locale }: TGetPlaceDetailsPayload, { signal }: TQueryConfig) =>
    axiosInstance<TGetPlaceDetailsData>({
      method: 'GET',
      headers: {
        'X-Goog-FieldMask': 'addressComponents,formattedAddress,location',
        'Content-Type': 'application/json',
      },
      url: `${env.EXPO_PUBLIC_WEB_BASE_URL}${PLACES_API_PATH}/places/${placeId}`,
      params: { languageCode: locale },
      signal,
    }).then((response) => response.data),
}
